































































import { Component, Ref } from "vue-property-decorator"
import Vue from "vue"
import { Cliente, Venda } from "@/models"
import { CashbackCrmBonusUseCase } from "@/usecases/cliente/CashbackCrmBonusUseCase"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"
import SeletorDeCliente from "../clientes/SeletorDeCliente.vue"
import { formatarMoeda } from '@/shareds/formatadores'

@Component({
	components: {
		SeletorDeCliente,
	},
})
export default class DialogoDeConsultarCashbackCrmBonus extends Vue {
	@Ref() form!: HTMLFormElement

	mostra = false
	venda: Venda | null = null
	lojaId: string | null = null
	cliente: Cliente | null = null
	carregando = false
	valorTotal = 0
	valorFuturo = 0
	consultou = false

	cashbackCrmBonusUseCase = new CashbackCrmBonusUseCase()
	formatarMoeda = formatarMoeda

	mostrar(lojaId: string, venda: Venda) {
		this.venda = venda
		this.lojaId = lojaId
		this.mostra = true
	}

	fechar(){
		this.mostra = false
		this.cliente = null
		this.consultou = false
		this.valorTotal = 0
		this.valorFuturo = 0
	}

	get temResultado() {
		return this.consultou
	}

	async consultar(){
		if (!this.cliente) return AlertModule.setError("Necessário informar um cliente.")
		if (!this.lojaId) return

		this.carregando = true

		try {
			const retorno = await this.cashbackCrmBonusUseCase.consultarCashbackDisponivelDoClienteNoCrm(this.lojaId, this.cliente.cnpjOuCpf)
			this.valorTotal = retorno.valorDisponivel
			this.valorFuturo = retorno.valorFuturo
			this.consultou = true

		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}
}
